import * as jsxRuntime from "/home/runner/work/diesel_landing/diesel_landing/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment